import { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Drawer, Stack, IconButton } from "@mui/material";
import lz from "lzutf8";
import { HugeiconsIcon } from "@hugeicons/react";
import { CancelSquareIcon } from "@hugeicons/core-free-icons";
import { WebsiteContext } from "../WebsiteProvider";
import WebComponentReader from "./WebComponentReader";
import { useResponsive } from "@/hooks";

const DrawerReader = () => {
  const navigate = useNavigate();
  const { elements, theme } = useContext(WebsiteContext);
  const { isMobile } = useResponsive();

  const drawer = useMemo(() => {
    const qs = new URLSearchParams(document.location.search);
    if (!qs.has("drawer")) return null;
    return elements?.find((d) => d.id === qs.get("drawer"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elements, document.location.search]);

  const json = useMemo(() => {
    if (!drawer) return null;
    return lz.decompress(lz.decodeBase64(String(drawer?.data ?? "")));
  }, [drawer]);

  const handleCloseDrawer = () => {
    const qs = new URLSearchParams(document.location.search);

    if (qs.has("drawer")) {
      qs.delete("drawer");
    }

    if (qs.size > 0) {
      const url = document.location.pathname + "?" + qs.toString();
      navigate(url);
    } else {
      const url = document.location.pathname;
      navigate(url);
    }
  };

  return (
    <Drawer
      open={!!drawer}
      anchor={drawer?.position ?? "right"}
      onClose={handleCloseDrawer}
      slotProps={{
        paper: {
          sx: {
            width: isMobile ? "100%" : drawer?.width,
          },
        },
      }}
    >
      <Box sx={{}}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <IconButton
            className="onCloseBtn"
            onClick={handleCloseDrawer}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              zIndex: 1,
            }}
          >
            <HugeiconsIcon icon={CancelSquareIcon} color={theme?.palette.primary.main} size={32} />
          </IconButton>
        </Stack>
        <WebComponentReader isLoading={!json} json={json} />
      </Box>
    </Drawer>
  );
};

export default DrawerReader;
